import { createSlice } from '@reduxjs/toolkit'

export const businessSlice = createSlice({
  name: 'business',
  initialState: {
    businessName: 'Teknikforce',
    files: [],
    businessDescription: 'Teknikforce Ventures LLC is a fast-growing creator of high-quality and unique Internet marketing tools for online marketers. We create web based and desktop based software to help you get things done better and faster.',
    phoneNumber: '+00-35353673456',
    email: 'business@teknikforce.com',
    website: 'https://teknikforce.com/',
    openingHours: [
      { day: 'Monday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      { day: 'Tuesday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      { day: 'Wednesday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      { day: 'Thursday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      { day: 'Friday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      { day: 'Saturday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      { day: 'Sunday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
    ],
    isHideAddress:true,
    font: 'Arial',
    cardColor: '#ffffff',
    titleTextColor: '#000000',
    descriptionColor: '#000000',
    contactDivBgColor: '#eaedff',
    contactHeadingColor: '#000000',
    contactIconColor: '#000000',
    contactDataColor: '#5c58fb',
    locationBgColor: '#5c58fb',
    locationIconColor: '#000000',
    locationTextColor: '#ffffff',
    tableHeadingBgColor: '#eaedff',
    tableHeadingColor: '#5c58fb',
    tableDataColor: '#000000',
    saveContactButtonBgColor: '#1e2746',
    saveContactButtonTextColor: '#ffffff'
  },
  reducers: {
    setBusinessField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setBusinessLogo(state, action) {
      state.files[0] = action.payload
    },
    setDayCheck(state, action) {
      state.dayCheck = action.payload
    },
     toggleHideAddress(state) {
      state.isHideAddress = !state.isHideAddress
    },
setOpeningHours(state, action) {
  const { method, type, dayIdx, hourIdx, hour, checked } = action.payload
  switch (method) {
    case 'add':
      state.openingHours[dayIdx].hours.push(hour)
      return
    case 'remove':
      state.openingHours[dayIdx].hours.splice(hourIdx, 1)
      return
    default:
      if (type === 'start') {
        state.openingHours[dayIdx].hours[hourIdx].start = hour
      } else if (type === 'end') {
        state.openingHours[dayIdx].hours[hourIdx].end = hour
      } else {
            state.openingHours[dayIdx].checked = checked
          }
      return
  }
},
    initializeBusiness(state, action) {
      state.businessName = 'Teknikforce'
      state.files = []
      state.businessDescription = 'Teknikforce Ventures LLC is a fast-growing creator of high-quality and unique Internet marketing tools for online marketers. We create web based and desktop based software to help you get things done better and faster.'
      state.phoneNumber = '+00-35353673456'
      state.email = 'business@teknikforce.com'
      state.website = 'https://teknikforce.com/'
      state.openingHours = [
        { day: 'Monday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
        { day: 'Tuesday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
        { day: 'Wednesday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
        { day: 'Thursday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
        { day: 'Friday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
        { day: 'Saturday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
        { day: 'Sunday', hours: [{ start: '08:00 AM', end: '01:00 PM' }], checked: true },
      ]
      state.isHideAddress = true
      state.font = 'Arial'
      state.cardColor = '#ffffff'
      state.titleTextColor = '#000000'
      state.descriptionColor = '#000000'
      state.contactDivBgColor = '#eaedff'
      state.contactHeadingColor = '#000000'
      state.contactIconColor = '#000000'
      state.contactDataColor = '#5c58fb'
      state.locationBgColor = '#5c58fb'
      state.locationIconColor = '#000000'
      state.locationTextColor = '#ffffff'
      state.tableHeadingBgColor = '#f0f0f0'
      state.tableHeadingColor = '#000000'
      state.tableDataColor = '#000000'
      state.saveContactButtonBgColor = '#1e2746'
      state.saveContactButtonTextColor = '#ffffff'
    }
  }
})

export const {
  setBusinessField,
  setBusinessLogo,
  setOpeningHours,
  initializeBusiness,
  toggleHideAddress
} = businessSlice.actions
export default businessSlice.reducer